/* =========================================================================
   Post-auth resume hook. When a guest chooses "Create free account" MID-GAME
   (from the register prompt), the controller stashes a resume closure here and
   hands off to the auth screens. On the first successful register/login,
   auth.ts's afterAuthSuccess consumes it to drop the player back into the exact
   run they left (the engine/ctx state survives the screen swaps) — skipping the
   results/pendingSummary flow, since there is no completed game mid-run.
   Kept dependency-free so both auth.ts and gameController.ts can share it
   without an import cycle.
   ========================================================================= */
let resumeFn: (() => void) | null = null;

export function setPostAuthResume(fn: (() => void) | null): void {
  resumeFn = fn;
}

/** Read and clear the pending resume (single-shot so it can never double-fire). */
export function consumePostAuthResume(): (() => void) | null {
  const f = resumeFn;
  resumeFn = null;
  return f;
}

export function hasPostAuthResume(): boolean {
  return resumeFn !== null;
}
